import { Component, OnInit, Input, OnChanges } from '@angular/core'
import { Observable, Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import { ActivatedRoute } from '@angular/router'
import {
  FormControl,
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { CommonModule } from '@angular/common'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload'
import { NzImageModule } from 'ng-zorro-antd/image'
import { NzInputModule } from 'ng-zorro-antd/input'
import { NzCardModule } from 'ng-zorro-antd/card'
import { NzFormModule } from 'ng-zorro-antd/form'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { QuestionService } from './question.service'
import { LoadingService } from 'src/app/share/services/loading.service'


@Component({
  selector: 'app-question-builder',
  templateUrl: './question-builder.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzCollapseModule,
    CommonModule,
    NzButtonModule,
    NzIconModule,
    NzUploadModule,
    NzImageModule,
    NzInputModule,
    NzCardModule,
    NzFormModule,
    NzDatePickerModule,
    NzStepsModule
  ],
  styleUrls: ['./question-builder.component.scss'],
})
export class QuestionBuilderComponent implements OnInit, OnChanges {
  // for course Id
  @Input() quizId: string;
  // pre / final
  @Input() type: string;
  // quiz type
  choice: string;

  form: FormGroup;
  dataSub: Subscription;
  data: Array<any>;
  newQuestion: any = [];
  newQuiz: any = [];
  questionMsg: string;

  imageList: string[] = [];
  // testdata: any = {
  //   is_input: false,
  //   image: '',
  //   id: '',
  //   course_id: '',
  //   name: 'That is Testing',
  //   type: 'single',
  //   questionnaireType: 'single',
  //   questionnaire: [],
  // };

  constructor(
    private questionService: QuestionService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    // private formService: FormService
  ) { }
  ngOnInit() {

    this.buildForm()
    console.log(this.quizId);
    this.getAllData();
    this.clearFormArray(this.quizLists());
    this.newQuestion = []
    this.newQuiz = []
  }

  ngOnChanges() {
    this.buildForm();
    this.getAllData();
  }

  getAllData() {
    this.questionService.getItemsByQuizId({ id: this.quizId }).subscribe({
      next: (x: any) => {
        this.data = x.data;
        this.clearFormArray(this.quizLists());
        this.imageList = [];
        this.data.forEach((value: any, index) => {
          this.imageList.push(value.image);
          this.doAddQuiz('', value)
          this.dataParse(value, index)
          this.newQuestion = []
          this.newQuiz = []
        });
      },

    });
    // const filterValure = { course_id: this.courseId, type: this.type }
    // this.quizService.getQuizzes(JSON.stringify(filterValure))
    // this.dataSub = this.quizService
    //   .getQuizListener()
    //   .pipe(take(1))
    //   .subscribe(
    //     async (postData: { quizzes: Array<IQuiz>; quizCount: number }) => {
    //       this.data = postData.quizzes
    //       this.formService.clearFormArray(this.quizLists())
    //       this.data.forEach((value: any, index) => {
    //         this.doAddQuiz('', value)
    //         this.dataParse(value, index)
    //         this.newQuestion = []
    //         this.newQuiz = []
    //       })
    //     }
    //   )
  }

  buildForm() {
    this.form = this.fb.group({
      quiz_lists: this.fb.array([]),
    })
  }

  quizLists(): FormArray {
    return this.form.get('quiz_lists') as FormArray
  }

  doAddQuiz(type?: any, value?: any) {
    this.choice = type
    this.quizLists().push(this.addQuizForm(value))
    this.getCurrentNewQuiz()
  }

  addQuizForm(value?: any): FormGroup {
    console.log(this.quizId);
    const quizFormGroup = this.fb.group({
      is_input: [true],
      image: [''],
      id: [''],
      quiz_id: [this.quizId],
      name: ['', Validators.required],
      type: [this.type],
      questionnaireType: [this.choice],
      questionnaire: this.fb.array(value?.id ? [] : [this.createItem()]),
    })
    return quizFormGroup
  }

  onSubmit(quizIndex: number) {
    if (this.quizLists().controls[quizIndex].invalid)
      return this.validateAllFormFields(
        this.quizLists().controls[quizIndex] as FormGroup
      )
    const quiz = this.quizLists().controls[quizIndex].value
    const checkedQuiz = quiz.questionnaire.filter((ques: any) => {
      if (ques.correct) return ques
    })
    if (checkedQuiz.length === 0) {
      this.questionMsg = '*Please choose the right answer!'
    } else {
      this.loadingService.showLoading();
      if (quiz.id) {
        this.questionService
          .updateItem(quiz)
          .subscribe((value: any) => {
            this.getAllData();
            this.loadingService.hideLoading();
          })
        this.questionMsg = ''
      }
      else {
        this.questionService
          .createItem(quiz)
          .subscribe((value: any) => {
            this.getAllData();
            this.loadingService.hideLoading();
          })
        this.questionMsg = ''
      }

    }
  }

  // data bind in form
  dataParse(data: any, index: number) {
    console.log('enter');
    this.quizLists().controls[index].patchValue({
      id: data?.id,
      is_input: false,
      image: data.image,
      name: data.name,
      type: data.type,
      questionnaireType: data.questionnaireType,
    })
    const subArray = this.quizLists().controls[index].get(
      'questionnaire'
    ) as FormArray
    data.questionnaire.forEach((q: any) => {
      subArray.push(
        this.fb.group({
          question_title: q.question_title,
          correct: q.correct,
          is_input: false,
        })
      )
    })
  }

  questionLists(i: any): FormArray {
    return this.quizLists().controls[i].get('questionnaire') as FormArray
  }

  // create question form
  createNewQuestion(i: any) {
    this.questionLists(i).push(this.createItem())
    this.getCurrentNewQues(i)
  }

  // get new questions
  getCurrentNewQues(i: any) {
    this.newQuestion = this.questionLists(i).value.filter((q: any) => {
      return q.is_input === true
    })
  }

  // get new quiz
  getCurrentNewQuiz() {
    this.newQuiz = this.quizLists().value.filter((q: any) => {
      return q.is_input === true
    })
  }

  // save quiz's questions
  saveQuizQuestion(i: any) {
    // const quiz = this.quizLists().controls[i].value
    // this.quizService
    //   .saveQuiz(quiz.id ? quiz.id : undefined, quiz)
    //   .subscribe((value: any) => {
    //     this.getAllData()
    //   })
  }

  // filter checked for checbox if the quiz is single
  questionCheck(event: any, i: any, j: any, type?: string) {
    if (type === 'single')
      this.questionLists(i).controls.forEach((q, index) => {
        this.questionLists(i).controls[index].patchValue({
          correct: j !== index ? false : true,
        })
      })
    else
      this.questionLists(i).controls[j].patchValue({
        correct: event.target.checked,
      })
  }

  // remove quiz's question
  removeQuestion(i: any, j: any) {
    if (j > 0) {
      this.questionLists(i).removeAt(j)
      this.getCurrentNewQues(i)
    } else {
      this.questionMsg = 'Quiz should have at least one question'
    }
  }

  // form group of quiz's question
  createItem(questionTitle?: any, correct?: any) {
    return this.fb.group({
      is_input: [true],
      question_title: [
        questionTitle === undefined ? '' : questionTitle,
        Validators.required,
      ],
      correct: [correct === undefined ? false : correct],
    })
  }

  // delete quiz
  doDelete(i: any) {
    // const quiz = this.quizLists().controls[i]
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: `You won't be able to revert this!`,
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: 'Yes, delete it!',
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonText: 'No, cancel!',
    //   cancelButtonColor: '#d33',
    // }).then((result) => {
    //   if (result.value) {
    //     this.db.delete(`quiz/delete`, [quiz.get('id').value]).subscribe(
    //       async () => {
    //         Swal.fire('Deleted!', 'Item has been deleted.', 'success')
    //         this.getAllData()
    //       },
    //       (error) => {
    //         Swal.fire('Cancelled', 'Item is not deleted.', 'error')
    //       }
    //     )
    //   } else if (result.dismiss === Swal.DismissReason.cancel) {
    //     Swal.fire('Cancelled', 'Item is not deleted.', 'error')
    //   }
    // })
  }

  // change to edit form
  doEdit(i: any, quiz: any) {
    console.log(quiz);
    console.log(quiz.questionnaire);
    this.quizLists().controls[i].patchValue({
      is_input: true,
      image: quiz.image
    })
    quiz.questionnaire.forEach((q: any, index: any) => {
      if (this.questionLists(i).controls[index]) {
        this.questionLists(i).controls[index].patchValue({
          is_input: true,
        })
      }
    })
  }

  // clear quiz
  doCancel(i: any, questionnaire: any) {
    const quiz = this.quizLists().controls[i].value
    if (!quiz.id) {
      this.quizLists().removeAt(i)
      this.newQuiz = []
      this.questionMsg = ''
    } else {
      this.quizLists().controls[i].patchValue({
        is_input: false,
      })
      questionnaire.forEach((q: any, index: any) => {
        if (this.questionLists(i).controls[index]) {
          this.questionLists(i).controls[index].patchValue({
            is_input: false,
          })
        }
      })
      this.questionMsg = ''
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field)
      if (control instanceof FormArray) {
        for (const control1 of control.controls) {
          if (control1 instanceof FormControl) {
            control1.markAsTouched({
              onlySelf: true,
            })
          }
          if (control1 instanceof FormGroup) {
            this.validateAllFormFields(control1)
          }
        }
      }
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        })
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control)
      }
    })
  }

  // beforeUpload = (file: NzUploadFile): boolean => {
  //   const rawFile = file as unknown as File;
  //   if (!rawFile) {
  //     console.error('Invalid file object');
  //     return false;
  //   }

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.image = reader.result as string;
  //   };

  //   reader.readAsDataURL(rawFile);
  //   return true;
  // };

  beforeUpload(index: number, file: NzUploadFile): boolean | Observable<boolean> {
    const rawFile = file as unknown as File;
    if (!rawFile) {
      console.error('Invalid file object');
      return false;
    }

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        this.imageList.splice(index, 0, reader.result as string);
        console.log(this.imageList);
      }
    };

    reader.readAsDataURL(rawFile);
    return true;
  }

  handleChange(info: { file: NzUploadFile }, index: number): void {
    let formControl: any = (this.form?.get('quiz_lists') as FormArray)?.at(index).get('image');
    console.log(formControl);
    const file = info.file;
    formControl.setValue(info.file!.originFileObj!);
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  deleteImage(event: any, index: number) {
    event.stopPropagation();
    event.preventDefault();
    this.quizLists().controls[index].get('image').setValue('');
    this.imageList[index] = '';
  }
}
